module.exports = __webpack_public_path__ + "img/cornerLeftBottom.323e35f3.svg";